const Sales = () => {
  return (
    <>
      <h2>Sales</h2>
    </>
  );
};

export default Sales;
